/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchReminderData = createAsyncThunk('fetchReminderData', async () => {
    try {
        const response = await apiget(`api/reminder/`);
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const reminderSlice = createSlice({
    name: 'reminderDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchReminderData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchReminderData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchReminderData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default reminderSlice.reducer;